import {
    ApiHandlerNoApiParameter,
    HasOnComplete,
    HasOnSuccess,
    makeHandlerChainAwaitable,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { createShipTo, updateShipTo as updateShipToApi } from "@insite/client-framework/Services/CustomersService";
import {
    AddOrUpdateShipTo,
    LoadSession,
    UpdateSession,
    LoadCart,
    UpdateCart
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateShipTo";
import { chain } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateShipTo";
import loadShipTo from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTo";
import { updateSession } from "@insite/client-framework/Services/SessionService";
import loadSession from "@insite/client-framework/Store/Context/Handlers/LoadSession";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { updateCart as updateCartApi } from "@insite/client-framework/Services/CartService";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

export type HandlerTypeUpdateShipTo = ApiHandlerNoApiParameter<
    {
        billToId: string;
        shipTo: ShipToModel;
        properties: any;
        isEdit:boolean;
    } & HasOnSuccess<boolean> & HasOnComplete,
    ShipToModel
>;

export const AddOrUpdateShipToCustom: HandlerTypeUpdateShipTo = async props => {
    if (props.parameter.shipTo.isNew) {
        props.apiResult = await createShipTo({
            shipTo: props.parameter.shipTo,
        });
    } else {
        props.apiResult = await updateShipToApi({
            billToId: props.parameter.billToId,
            shipTo: props.parameter.shipTo,
        });
    }

    if (!props.parameter.shipTo?.properties?.isLocalDeleted) {
        // reload to make sure we get validation
        await makeHandlerChainAwaitable(loadShipTo)({
            billToId: props.parameter.billToId,
            shipToId: props.apiResult.id,
        })(props.dispatch, props.getState);
    }
    props.parameter.onComplete && props.parameter.onComplete(props.apiResult);
};

export const UpdateSessionCustom: HandlerTypeUpdateShipTo = async props => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    if ((props.parameter.shipTo.properties?.isShipToSelected || props.parameter.properties?.notLoadSession) && !props.parameter.properties?.skipUpdateCart) {
        const cart = getCartState(state, cartId || "current").value!;
        await updateCartApi({
            cart: {
                ...cart,
                shipToId: props.apiResult.id,
            },
        });
        props.dispatch(loadCart({ cartId: cart.id || "current" }));
    } else {
        if (!cartId && props.apiResult && !props.parameter.shipTo?.properties?.isLocalDeleted && !props.parameter.properties?.notLoadSession) {
            await updateSession({
                session: {
                    billToId: props.parameter.billToId,
                    shipToId: props.apiResult.id,
                    customerWasUpdated: true,
                },
            });
        }
    }
};

export const LoadSessionCustom: HandlerTypeUpdateShipTo = async props => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutShipping;

    if (
        !cartId &&
        props.apiResult &&
        !props.parameter.shipTo?.properties?.isLocalDeleted &&
        !props.parameter.shipTo.properties?.isShipToSelected &&
        !props.parameter.properties?.notLoadSession
    ) {
        props.dispatch(loadSession());
    }
};

export const UpdateCartCustom: HandlerTypeUpdateShipTo = async props => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutShipping;
    if (cartId && props.apiResult && !props.parameter.properties?.skipUpdateCart) {
        const cart = getCartState(state, cartId).value!;
        await updateCartApi({
            cart: {
                ...cart,
                shipToId: props.apiResult.id,
            },
        });
    }
};

export const LoadCartCustom: HandlerTypeUpdateShipTo = async props => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutShipping;
    if (cartId && !props.parameter.properties?.skipUpdateCart) {
        props.dispatch(loadCart({ cartId }));
    } else if (!props.parameter.properties?.skipUpdateCart) {
        await makeHandlerChainAwaitable(loadCurrentCart)({ OnSuccess: () => {}, getPromotions: true })(
            props.dispatch,
            props.getState,
        );
    }
};

replaceInChain(chain, AddOrUpdateShipTo, AddOrUpdateShipToCustom);
replaceInChain(chain, UpdateSession, UpdateSessionCustom);
replaceInChain(chain, LoadSession, LoadSessionCustom);
replaceInChain(chain, LoadCart, LoadCartCustom);
replaceInChain(chain, UpdateCart, UpdateCartCustom);